<div
  (click)="clickPagination()"
  (keydown)="clickPagination()">
  <desy-pagination
    [id]="this.config.id"
    [itemsPerPage]="this.config.itemsPerPage"
    [totalItems]="this.config.totalItems"
    [hasSelect]="true"
    [hasNext]="true"
    [hasPrevious]="true"
    [idPrefix]="'selector'"
    [previousText]="this.config.previousText"
    [nextText]="this.config.nextText"
    [(currentPage)]="this.pageNow"></desy-pagination>
</div>
